"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT = exports.STATE_LIST = exports.SESSION_DURATION = exports.PAYMENT_STATUSES = exports.BOOKING_STATE = void 0;
var TRANSLATION = {
  payment_due: 'Pending payment',
  processing_payment: 'Payment processing',
  payment_pending: 'Pending payment',
  paymemtSuccess: 'Payment success',
  failed: 'Payment failed',
  payment_dueMessage: 'We are waiting payment for this booking. Pay before the timer limit to confirm your booking.',
  processing_paymentMessage: "We're waiting for confirmation from bank there's no need to pay again.",
  payment_pendingMessage: 'Your last payment attempt has failed. Try again before the time limit to confirm your booking.',
  failedMessage:
  // eslint-disable-next-line max-len
  'We are sorry, your payment is rejected by the system or acquiring host. Please make a new booking and try using another payment method.',
  payNow: 'Pay now',
  lastPaymentAttempt: 'Last payment attempt',
  Failed: 'Failed',
  Processing: 'Processing'
};
exports.TRANSLATION = TRANSLATION;
var TEXT = {
  left: 'left',
  default: 'default',
  greyDarker: 'greyDarker',
  greyDark: 'greyDark',
  secondary: 'secondary',
  small: 'small',
  textLarge: 'textLarge',
  black: 'black',
  orange: 'orange',
  button: 'button',
  medium: 'medium',
  payment_pending: 'yellow',
  payment_due: 'yellow',
  failed: 'tertiaryRed',
  processing_payment: 'yellow',
  yellowLight: 'yellowLight'
};
exports.TEXT = TEXT;
var BOOKING_STATE = {
  bookingConfirmed: 'success',
  processingPayment: 'processing_payment',
  paymentPending: 'payment_due',
  pending: 'pending',
  bookingFailed: 'failed'
};
exports.BOOKING_STATE = BOOKING_STATE;
var SESSION_DURATION = 30;
exports.SESSION_DURATION = SESSION_DURATION;
var STATE_LIST = {
  PROCESSING: 'payment_processing',
  FAILED: 'payment_failed'
};
exports.STATE_LIST = STATE_LIST;
var PAYMENT_STATUSES = {
  PROCESSING: 'Processing',
  FAILED: 'Failed'
};
exports.PAYMENT_STATUSES = PAYMENT_STATUSES;